import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchFutureDeliveries = createAsyncThunk(
  "futureDelivery/fetchFutureDeliveries",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/admin/future-deliveries", {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const pushFutureDelivery = createAsyncThunk(
  "futureDelivery/pushFutureDelivery",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      const response = await apiService.post(
        `/admin/push-delivery/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const futureDeliverySlice = createSlice({
  name: "futureDelivery",
  initialState: {
    futureDeliveries: [],
    status: "idle",
    error: null,
    pushStatus: "idle", // 👈 NEW
    pushError: null, // 👈 NEW
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchFutureDeliveries.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchFutureDeliveries.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.futureDeliveries = action.payload.data;
      })
      .addCase(fetchFutureDeliveries.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      .addCase(pushFutureDelivery.pending, (state) => {
        state.pushStatus = "loading";
        state.pushError = null;
      })
      .addCase(pushFutureDelivery.fulfilled, (state, action) => {
        state.pushStatus = "succeeded";
      })
      .addCase(pushFutureDelivery.rejected, (state, action) => {
        state.pushStatus = "failed";
        state.pushError = action.payload?.message || "Failed to push delivery";
      });
  },
});

export default futureDeliverySlice.reducer;
